// Timeline configurations with Rejected status
// Note: Rejected can happen at any review stage except Payroll/Paid
// After rejection, the applicant fixes and resubmits, going through the whole process again

export type TimelineStep = { status: string; role: string };

export const TIMELINE_CONFIGS = {
  CCM1: [
    { status: "Created", role: "DCCM" },
    { status: "Draft", role: "DCCM" },
    { status: "Submitted", role: "DCCM" },
    { status: "Bonus_Recipient_Review", role: "CCM1" },
    { status: "VP_Review", role: "VP" },
    { status: "Ops_Review", role: "Ops" },
    { status: "Approved", role: "Ops" },
    { status: "Payroll_Processing", role: "Payroll" },
    { status: "Paid", role: "Paid" },
    { status: "Rejected", role: "Rejected" }, // Can be rejected at any review stage
  ],
  CCM2: [
    { status: "Created", role: "DCCM" },
    { status: "Draft", role: "DCCM" },
    { status: "Submitted", role: "DCCM" },
    { status: "Bonus_Recipient_Review", role: "CCM2" },
    { status: "VP_Review", role: "VP" },
    { status: "Ops_Review", role: "Ops" },
    { status: "Approved", role: "Ops" },
    { status: "Payroll_Processing", role: "Payroll" },
    { status: "Paid", role: "Paid" },
    { status: "Rejected", role: "Rejected" },
  ],
  CCM3: [
    { status: "Created", role: "DCCM" },
    { status: "Draft", role: "DCCM" },
    { status: "Submitted", role: "DCCM" },
    { status: "Bonus_Recipient_Review", role: "CCM3" },
    { status: "VP_Review", role: "VP" },
    { status: "Ops_Review", role: "Ops" },
    { status: "Approved", role: "Ops" },
    { status: "Payroll_Processing", role: "Payroll" },
    { status: "Paid", role: "Paid" },
    { status: "Rejected", role: "Rejected" },
  ],
  CCM3Manager: [
    { status: "Created", role: "DCCM" },
    { status: "Draft", role: "DCCM" },
    { status: "Submitted", role: "DCCM" },
    { status: "Bonus_Recipient_Review", role: "CCM3Manager" },
    { status: "VP_Review", role: "VP" },
    { status: "Ops_Review", role: "Ops" },
    { status: "Approved", role: "Ops" },
    { status: "Payroll_Processing", role: "Payroll" },
    { status: "Paid", role: "Paid" },
    { status: "Rejected", role: "Rejected" },
  ],
  CM3: [
    { status: "Created", role: "DM" },
    { status: "Draft", role: "DM" },
    { status: "Submitted", role: "DM" },
    { status: "Bonus_Recipient_Review", role: "CM3" },
    { status: "VP_Review", role: "VP" },
    { status: "Ops_Review", role: "Ops" },
    { status: "Approved", role: "Ops" },
    { status: "Payroll_Processing", role: "Payroll" },
    { status: "Paid", role: "Paid" },
    { status: "Rejected", role: "Rejected" },
  ],
  PM: [
    { status: "Created", role: "DM" },
    { status: "Draft", role: "DM" },
    { status: "Submitted", role: "DM" },
    { status: "Bonus_Recipient_Review", role: "PM" },
    { status: "VP_Review", role: "VP" },
    { status: "Ops_Review", role: "Ops" },
    { status: "Approved", role: "Ops" },
    { status: "Payroll_Processing", role: "Payroll" },
    { status: "Paid", role: "Paid" },
    { status: "Rejected", role: "Rejected" },
  ],
  DCCM: [
    { status: "Created", role: "VP" },
    { status: "Draft", role: "VP" },
    { status: "Submitted", role: "VP" },
    { status: "Bonus_Recipient_Review", role: "DCCM" },
    { status: "Ops_Review", role: "Ops" },
    { status: "Approved", role: "Ops" },
    { status: "Payroll_Processing", role: "Payroll" },
    { status: "Paid", role: "Paid" },
    { status: "Rejected", role: "Rejected" },
  ],
  SPM: [
    { status: "Created", role: "DM" },
    { status: "Draft", role: "DM" },
    { status: "Submitted", role: "DM" },
    { status: "Bonus_Recipient_Review", role: "SPM" },
    { status: "VP_Review", role: "VP" },
    { status: "Ops_Review", role: "Ops" },
    { status: "Approved", role: "Ops" },
    { status: "Payroll_Processing", role: "Payroll" },
    { status: "Paid", role: "Paid" },
    { status: "Rejected", role: "Rejected" },
  ],
};

// Helper to get workflow stages that can reject
export const REJECTABLE_STAGES = [
  "Bonus_Recipient_Review",
  "VP",
  "Ops",
];

// Helper to check if a status is a review stage that can reject
export const isRejectableStage = (status: string): boolean => {
  return REJECTABLE_STAGES.includes(status);
};

export const TIMELINE_CONFIGS_2025 = {
  CCM1: [
    { status: "Created", role: "CCM1" },
    { status: "Draft", role: "CCM1" },
    { status: "Submitted", role: "CCM1" },
    { status: "DCCM_Review", role: "DCCM" },
    { status: "VP_Review", role: "VP" },
    { status: "Ops_Review", role: "Ops" },
    { status: "Approved", role: "Ops" },
    { status: "Payroll_Processing", role: "Payroll" },
    { status: "Paid", role: "Paid" },
    { status: "Rejected", role: "Rejected" }, // Can be rejected at any review stage
  ],
  CCM2: [
    { status: "Created", role: "CCM2" },
    { status: "Draft", role: "CCM2" },
    { status: "Submitted", role: "CCM2" },
    { status: "DCCM_Review", role: "DCCM" },
    { status: "VP_Review", role: "VP" },
    { status: "Ops_Review", role: "Ops" },
    { status: "Approved", role: "Ops" },
    { status: "Payroll_Processing", role: "Payroll" },
    { status: "Paid", role: "Paid" },
    { status: "Rejected", role: "Rejected" },
  ],
  CCM3: [
    { status: "Created", role: "CCM3" },
    { status: "Draft", role: "CCM3" },
    { status: "Submitted", role: "CCM3" },
    { status: "DCCM_Review", role: "DCCM" },
    { status: "VP_Review", role: "VP" },
    { status: "Ops_Review", role: "Ops" },
    { status: "Approved", role: "Ops" },
    { status: "Payroll_Processing", role: "Payroll" },
    { status: "Paid", role: "Paid" },
    { status: "Rejected", role: "Rejected" },
  ],
  CM3: [
    { status: "Created", role: "CM3" },
    { status: "Draft", role: "CM3" },
    { status: "Submitted", role: "CM3" },
    { status: "SPM_Review", role: "SPM" },
    { status: "DM_Review", role: "DM" },
    { status: "VP_Review", role: "VP" },
    { status: "Ops_Review", role: "Ops" },
    { status: "Approved", role: "Ops" },
    { status: "Payroll_Processing", role: "Payroll" },
    { status: "Paid", role: "Paid" },
    { status: "Rejected", role: "Rejected" },
  ],
  PM: [
    { status: "Created", role: "PM" },
    { status: "Draft", role: "PM" },
    { status: "Submitted", role: "PM" },
    { status: "SPM_Review", role: "SPM" },
    { status: "DM_Review", role: "DM" },
    { status: "VP_Review", role: "VP" },
    { status: "Ops_Review", role: "Ops" },
    { status: "Approved", role: "Ops" },
    { status: "Payroll_Processing", role: "Payroll" },
    { status: "Paid", role: "Paid" },
    { status: "Rejected", role: "Rejected" },
  ],
  DCCM: [
    { status: "Created", role: "DCCM" },
    { status: "Draft", role: "DCCM" },
    { status: "Submitted", role: "DCCM" },
    { status: "VP_Review", role: "VP" },
    { status: "Ops_Review", role: "Ops" },
    { status: "Approved", role: "Ops" },
    { status: "Payroll_Processing", role: "Payroll" },
    { status: "Paid", role: "Paid" },
    { status: "Rejected", role: "Rejected" },
  ],
  SPM: [
    { status: "Created", role: "SPM" },
    { status: "Draft", role: "SPM" },
    { status: "Submitted", role: "SPM" },
    { status: "DM_Review", role: "DM" },
    { status: "VP_Review", role: "VP" },
    { status: "Ops_Review", role: "Ops" },
    { status: "Approved", role: "Ops" },
    { status: "Payroll_Processing", role: "Payroll" },
    { status: "Paid", role: "Paid" },
    { status: "Rejected", role: "Rejected" },
  ],
};

// Helper to get workflow stages that can reject
export const REJECTABLE_STAGES_2025 = [
  "DCCM_Review",
  "SPM_Review",
  "DM_Review",
  "VP_Review",
  "Ops_Review",
];

// Helper to check if a status is a review stage that can reject
export const isRejectableStage_2025 = (status: string): boolean => {
  return REJECTABLE_STAGES_2025.includes(status);
};


export const getTimelineConfig = (applicationType: string, year: number): TimelineStep[] => {
  const configs = year >= 2026 ? TIMELINE_CONFIGS : TIMELINE_CONFIGS_2025;
  return (configs[applicationType as keyof typeof configs] as TimelineStep[]) || [];
};

export const getRejectableStages = (year: number): string[] => {
  return year >= 2026 ? REJECTABLE_STAGES : REJECTABLE_STAGES_2025;
};